<template>
	<v-row class="pb-offset ma-0">
		<v-col class="pa-0">
			<v-card elevation="1" class="background-2 round-card">
				<v-card-title class="pa-3">
					<p :class="{'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.smAndDown}">Impostazioni Area Clienti</p>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-container class="pa-0" fluid>
					<v-row class="pa-4 ma-0">
						<v-col class="pt-0 pb-2 px-4" cols="12">
							<v-subheader class="pl-0 pb-0 pt-3">Branding Area Clienti</v-subheader>
						</v-col>
						<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
							<v-text-field
								type="text"
								label="Nome Aziendale"
								v-model="settings['portal_company_name']"
								outlined
								dense
								hint="Verrà mostrato nell'area privata e nelle email"
								persistent-hint
							></v-text-field>
						</v-col>
						<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6"></v-col>

						<v-col class="pt-0 pb-2 px-4" cols="12">
							<v-subheader class="pl-0 pb-0 pt-3">Colore Primario Area Clienti</v-subheader>
						</v-col>
						<v-col class="pt-0 pb-0 px-4 text-center" cols="12" sm="12">
							<v-color-picker
								v-model="settings['portal_color']"
								hide-canvas
								show-swatches
								width="100%"
								class="pb-6 background-2"
								flat
								swatches-max-height="250px"
							></v-color-picker>
							<v-btn color="primary" @click="settings['portal_color'] = '#F8C11D'">Default</v-btn>
						</v-col>

						<v-col class="pt-0 pb-2 px-4" cols="12">
							<v-subheader class="pl-0 pb-0 pt-3">Logo Area Clienti</v-subheader>
						</v-col>
						<image-input v-model="settings.portal_logo" class="pl-4" :max-width="450" :max-heigth="450">
							<div slot="activator" class="pa-2" style="border-radius: 50% !important; border: 2px solid #ececec;">
								<v-avatar :size="120" v-ripple v-if="!settings.portal_logo" class="grey lighten-3 cursor-pointer">
									<v-icon :size="60">mdi-shield-account</v-icon>
								</v-avatar>
								<v-avatar v-else
									:size="120"
									v-ripple
									class="custom-avatar cursor-pointer"
									:style="{'background-image': 'url(' + settings.portal_logo + ')'}">
								</v-avatar>
							</div>
						</image-input>
						<v-col class="pt-0 pb-2 px-4" cols="12">
							<v-subheader class="pl-0 pb-0 pt-3">Notifiche Scadenza Documenti</v-subheader>
						</v-col>
						<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
							<v-text-field
								type="number"
								label="Giorni prima della scadenza per promemoria"
								v-model="settings['portal_expiry_reminder_days']"
								outlined
								dense
								hint="Quanti giorni prima della scadenza inviare la notifica di promemoria (default: 7)"
								persistent-hint
								min="1"
								max="90"
							></v-text-field>
						</v-col>
						<v-col class="pt-0 pb-2 px-4" cols="12">
							<v-subheader class="pl-0 pb-0 pt-3">Permessi Cliente</v-subheader>
						</v-col>
						<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
							<v-switch
								v-model="settings['portal_client_upload_enabled']"
								label="Consenti al cliente di caricare file"
								hint="Se disabilitato, nessun cliente potrà caricare file o creare cartelle. Il permesso può essere disabilitato anche per singolo utente."
								persistent-hint
								inset
							></v-switch>
						</v-col>
					</v-row>
				</v-container>
				<v-divider></v-divider>
				<v-card-actions class="pr-4 pb-2">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click.native="saveSettings()">Salva</v-btn>
				</v-card-actions>
			</v-card>

			<!-- Salvataggio dedicato: attivare la 2FA chiude le sessioni di chi non
			     l'ha ancora configurata, e il salvataggio generico qui sopra ignora
			     queste chiavi. -->
			<v-card elevation="1" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p :class="{'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.smAndDown}">Sicurezza accesso Area Clienti</p>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-form ref="securityForm" @submit.prevent="confirmSaveSecurity">
					<v-container class="pa-0" fluid>
						<v-row class="pa-4 ma-0">
							<v-col v-if="securityLoadError" class="pt-2 pb-0 px-4" cols="12">
								<v-alert type="warning" dense outlined class="mb-0">
									Impossibile caricare le impostazioni di sicurezza: ricarica la pagina prima di modificarle.
								</v-alert>
							</v-col>
							<v-col class="pt-0 pb-2 px-4" cols="12">
								<v-subheader class="pl-0 pb-0 pt-3">Requisiti password</v-subheader>
							</v-col>
							<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
								<v-text-field
									type="number"
									label="Lunghezza minima"
									v-model.number="security.password_policy.min_length"
									:rules="minLengthRules"
									outlined
									dense
									min="8"
									max="64"
									hint="Da 8 a 64 caratteri"
									persistent-hint
								></v-text-field>
							</v-col>
							<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6"></v-col>
							<v-col class="pt-0 pb-0 px-4" cols="12" sm="6" md="3">
								<v-switch v-model="security.password_policy.uppercase" label="Lettere maiuscole" inset hide-details></v-switch>
							</v-col>
							<v-col class="pt-0 pb-0 px-4" cols="12" sm="6" md="3">
								<v-switch v-model="security.password_policy.lowercase" label="Lettere minuscole" inset hide-details></v-switch>
							</v-col>
							<v-col class="pt-0 pb-0 px-4" cols="12" sm="6" md="3">
								<v-switch v-model="security.password_policy.numbers" label="Numeri" inset hide-details></v-switch>
							</v-col>
							<v-col class="pt-0 pb-0 px-4" cols="12" sm="6" md="3">
								<v-switch v-model="security.password_policy.symbols" label="Simboli" inset hide-details></v-switch>
							</v-col>
							<v-col class="pt-4 pb-0 px-4 text-caption grey--text" cols="12">
								Chi ha una password che non rispetta i requisiti dovrà cambiarla al prossimo accesso.
							</v-col>

							<v-col class="pt-0 pb-2 px-4" cols="12">
								<v-subheader class="pl-0 pb-0 pt-3">Verifica in due passaggi</v-subheader>
							</v-col>
							<v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
								<v-switch
									v-model="security.twofa_required"
									label="Verifica in due passaggi obbligatoria"
									hint="A ogni accesso gli utenti dovranno inserire il codice generato da un'app di autenticazione (Google Authenticator, Microsoft Authenticator...). Al primo accesso la configureranno inquadrando un codice QR."
									persistent-hint
									inset
								></v-switch>
							</v-col>

							<!-- Si aggiorna mentre si cambiano le opzioni, prima del salvataggio -->
							<v-col class="pt-6 pb-0 px-4" cols="12">
								<portal-security-meter
									:policy="security.password_policy"
									:twofa-required="security.twofa_required"
								></portal-security-meter>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
				<v-divider></v-divider>
				<v-card-actions class="pr-4 pb-2">
					<v-spacer></v-spacer>
					<v-btn text color="primary" :loading="savingSecurity" :disabled="!securityLoaded" @click="confirmSaveSecurity">Salva</v-btn>
				</v-card-actions>
			</v-card>

			<v-dialog v-model="twofaDialog" max-width="500" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3">
						<p class="pl-2 pl-xl-3">Attivare la verifica in due passaggi?</p>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pt-4 body-2">{{ twofaDialogText }}</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn text color="primary" :disabled="savingSecurity" @click="cancelTwofaDialog">Annulla</v-btn>
						<v-btn text color="info" :loading="savingSecurity" @click="saveSecurity">Attiva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<crud
				modelDef="portalusers"
				title="Utenti Area Clienti"
				actionIcon="mdi-shield-account"
				class="mt-4"
				:crudDialog="true"
			></crud>
		</v-col>
	</v-row>
</template>

<script>
import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
import Crud from '@/components/common/Crud'
import PortalSecurityMeter from '@/components/modules/portal/PortalSecurityMeter'
import { DEFAULT_PORTAL_PASSWORD_POLICY } from '@/components/modules/portal/portalPasswordPolicy'

export default {
	name: 'settings-portal',
	mixins: [SettingsOptionsMixin],
	components: {
		Crud,
		PortalSecurityMeter
	},
	data() {
		return {
			model: 'portal',
			settings: {
				'model': 'portal',
				'portal_company_name': '',
				'portal_color': '#F8C11D',
				'portal_logo': '',
				'portal_expiry_reminder_days': '7',
				'portal_client_upload_enabled': false
			},
			security: {
				password_policy: Object.assign({}, DEFAULT_PORTAL_PASSWORD_POLICY),
				twofa_required: false
			},
			// Valore salvato: il dialog di conferma serve solo al passaggio da spenta ad accesa
			twofaRequiredSaved: false,
			// Finche' la GET non e' riuscita la card mostra i default: salvarli
			// spegnerebbe la 2FA e azzererebbe i requisiti senza avvisare
			securityLoaded: false,
			securityLoadError: false,
			securityStats: { portal_users: 0, twofa_enrolled: 0 },
			savingSecurity: false,
			twofaDialog: false,
			minLengthRules: [
				v => (v !== '' && v !== null && !isNaN(v)) || 'Obbligatorio',
				v => (parseInt(v) >= 8 && parseInt(v) <= 64) || 'Da 8 a 64 caratteri'
			]
		}
	},
	computed: {
		twofaDialogText() {
			const toDisconnect = Math.max(0, this.securityStats.portal_users - this.securityStats.twofa_enrolled)
			if (toDisconnect === 0) {
				return 'Da questo momento tutti gli utenti dell\'Area Clienti dovranno inserire il codice dell\'app di autenticazione a ogni accesso.'
			}
			if (toDisconnect === 1) {
				return '1 utente dell\'Area Clienti non l\'ha ancora configurata: verrà disconnesso e al prossimo accesso dovrà inquadrare il codice QR con l\'app di autenticazione.'
			}
			return toDisconnect + ' utenti dell\'Area Clienti non l\'hanno ancora configurata: verranno disconnessi e al prossimo accesso dovranno inquadrare il codice QR con l\'app di autenticazione.'
		}
	},
	created() {
		this.loadSecurity()
	},
	methods: {
		applySecurity(data) {
			this.security = {
				password_policy: Object.assign({}, DEFAULT_PORTAL_PASSWORD_POLICY, data.password_policy),
				twofa_required: !!data.twofa_required
			}
			this.twofaRequiredSaved = !!data.twofa_required
			this.securityStats = data.stats
		},
		async loadSecurity() {
			try {
				// silent: un errore non deve portare l'intera pagina sulla 404
				const resp = await this.axios.get('portal-security-settings', { silent: true })
				if (resp.data.success) {
					this.applySecurity(resp.data.data)
					this.securityLoaded = true
					return
				}
			} catch (e) {
				// avviso nella card
			}
			this.securityLoadError = true
		},
		cancelTwofaDialog() {
			this.twofaDialog = false
			this.security.twofa_required = this.twofaRequiredSaved
		},
		confirmSaveSecurity() {
			if (!this.securityLoaded) return
			if (!this.$refs.securityForm.validate()) return
			if (this.security.twofa_required && !this.twofaRequiredSaved) {
				this.twofaDialog = true
				return
			}
			this.saveSecurity()
		},
		async saveSecurity() {
			if (this.savingSecurity) return
			this.savingSecurity = true
			try {
				const resp = await this.axios.post('portal-security-settings', {
					password_policy: Object.assign({}, this.security.password_policy, {
						min_length: parseInt(this.security.password_policy.min_length)
					}),
					twofa_required: this.security.twofa_required
				})
				if (resp.data.success) {
					this.applySecurity(resp.data.data)
					const revoked = resp.data.revoked_sessions
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: resp.data.message + (revoked > 0 ? ' (' + revoked + (revoked === 1 ? ' sessione chiusa)' : ' sessioni chiuse)') : ''),
						value: true,
						color: 'success'
					})
				}
			} catch (e) {
				// errore gia' segnalato dall'interceptor
			} finally {
				this.savingSecurity = false
				this.twofaDialog = false
			}
		}
	}
}
</script>
